import { Component, OnInit } from '@angular/core';
import { EmployeeService } from '../services/employee.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, } from '@angular/forms'
import { Meta, Title } from "@angular/platform-browser";
import * as $ from 'jquery';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  signupForm: FormGroup;
  private formSubmitAttempt: boolean;
  private istermschecked: boolean;
  private countryCode: string;
  constructor(private _employeeService: EmployeeService, private router: Router, private fb: FormBuilder, private meta: Meta, title: Title) {

    title.setTitle('SASA doctor');

    meta.addTags([
      { name: 'author', content: 'sasadoctor.com' },
      {
        name: 'keywords', content: 'SASAdoctor Virtual Medical Care,Telemedicine revolution for Kenya,End to End Virtual Medical Clinic,Android based Telemedicine platform,Work with your insurance provider,Affordable; high quality medical care by Kenya licensed and accredited doctors,Available 24 hours a day 7 days a week.'
      },
      { name: 'description', content: 'SASAdoctor' }
    ]);
    this.signupForm = fb.group({
      name: ['', Validators.compose([Validators.required, Validators.maxLength(15), Validators.minLength(1)])],

      email: ['', [
        //Validators.required,
        Validators.pattern("[^ @]*@[^ @]*")
      ]],
      mobile: ['', [Validators.required, Validators.maxLength(10), Validators.minLength(10), Validators.pattern("[0-9]+")]],
      istermschecked: ['',]
    })


  }

  ngOnInit() {
    // add metatags for seo
    this.meta.addTags([
      { name: 'author', content: 'sasadoctor.com' },
      { name: 'keywords', content: 'SASAdoctor Virtual Medical Care,Telemedicine revolution for Kenya,End to End Virtual Medical Clinic,Android based Telemedicine platform,Work with your insurance provider,Affordable; high quality medical care by Kenya licensed and accredited doctors,Available 24 hours a day 7 days a week.' },
      { name: 'description', content: 'SASAdoctor' }
    ]);
    // add metatags for seo

    const $ = window["$"];
    $('.menu-btn').on('click', function () {
      let elem = $(this),
        item = $('.menu__item'),
        active = 'is-active',
        play = 'menu__item--play';

      if (elem.hasClass(active)) {
        elem.removeClass(active);
        $(item.get().reverse()).each(function (i) {
          let row = $(this);
          setTimeout(function () {
            row.removeClass(play);
          }, 50 * i);
        });
      }

      else {
        elem.addClass(active);
        item.each(function (i) {
          let row = $(this);
          setTimeout(function () {
            row.addClass(play);
          }, 50 * i);
        });
      }

    });
    $('#joinNow').click(function () {
      $('html, body').animate({
        scrollTop: $($(this).attr('href')).offset().top
      }, 700);
      return false;
    });

    $("#testimonial-slider").owlCarousel({
      items: 2,
      itemsDesktop: [1000, 2],
      itemsDesktopSmall: [979, 2],
      itemsTablet: [768, 1],
      pagination: false,
      navigation: true,
      navigationText: ["", ""],
      autoPlay: true
    });

    $(".wish-icon i").click(function () {
      $(this).toggleClass("fa-heart fa-heart-o");
    });

    $(window).scroll(function () {
      let scroll = $(window).scrollTop();

      if (scroll >= 50) {
        $(".clearHeader").addClass("darkHeader");
      } else {
        $(".clearHeader").removeClass("darkHeader");
      }
    });

    $(".left-first-section").click(function () {
      $('.main-section').toggleClass("open-more");
    });

    $(".fa-minus").click(function () {
      $('.main-section').toggleClass("open-more");
    });


  }

  registerEmployee(employeeForm: FormGroup) {
    this.formSubmitAttempt = true;
    this.countryCode = (this.countryCode == null || this.countryCode == '') ? "254" : this.countryCode;
    if (employeeForm.invalid) {
      return;
    }
    else {
      if (this.istermschecked) {
        employeeForm.value.usertype = 1;
        employeeForm.value.mobile = this.countryCode + employeeForm.value.mobile;
        this._employeeService.saveWebUser(employeeForm.value).subscribe(
          data => {
            if (data.returnCode == 0) {
              alert("link for download SASA-Doctor app has been sent to your email ")
              this.formSubmitAttempt = false;
              this.istermschecked = false
              employeeForm.reset();
            }
            else {
              alert(data.returnMsg)

            }
          },
          error => {
            // this.alertService.error(error);
            // this.loading = false;         
            alert(error)
            console.log(error)
          });
      }
      else {
        alert("Verify Terms And Conditions")
        return;
      }

    }




  }

  conditionchecked(e) {
    if (e.target.checked) {
      this.istermschecked = true;
    }
    else {
      this.istermschecked = false;
    }
  }

  telInputObject(obj) {
    console.log(obj);
    obj.intlTelInput('setCountry', 'ke');
  }

  onCountryChange(obj) {
    this.countryCode = obj.dialCode
    console.log(obj);
  }

  getNumber(obj) {
    console.log(obj);
  }

}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts